module.exports = __webpack_public_path__ + "img/logo-social-media.d1225337.png";